import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Nav, Navbar, Container } from "react-bootstrap";
import { getState } from "../../../store/configure/configureStore";
import { Role } from "../../../constants/role";
import { ENABLE_BANNER_SCREEN } from "../../../constants/env";
//
import logo from "../../../assets/images/aol-logo.png";

// BsClipboard
import "./SidebarStyles.scss";
import {
  HOME,
  TEST_SCREEN,
  USER_MANAGEMENT,
  ADMIN_PANEL_USER_MANAGEMENT,
  MOBILE_APP_USER_MANAGEMENT,
  YOUTUBE_MANAGEMENT,
  INSTAGRAM_MANAGEMENT,
  BANNER_MANAGEMENT,
  NOTIFICATION_MANAGEMENT,
  TRANSACTION_HISTORY,
} from "../../../navigation/routes";

import { FaAngleDown, FaAngleRight } from "react-icons/fa";

//

const RenderSidebar = (
  logout,
  isOpen,
  hideSidebar,
  state,
  userPermissions,
  //
  rowReordered,
  setRowReorderWarningModal,
  setNavigatingToOtherPageWarningModal,
  resetBannerScreenFilter,
  showSelection,
  //
  persistMenuBar
) => {
  // console.log("rowReordered", rowReordered);
  // console.log("showSelection", showSelection);
  var permission = userPermissions;

  //--------------------------- redux state
  const isRowsSelected =
    getState().youtubeManagement?.selectedMultipleRowVideo?.length > 0;
  const activeMenuBar = getState().sidebar?.activeMenuBar;
  const userRole = getState().auth?.userRole;
  const isAdmin = userRole === Role.Administrator;

  const [showSubNav, setShowSubNav] = useState(activeMenuBar);
  // console.log("showSubNav", showSubNav);

  //toggle sub-navigation
  const showChildNav = (navItem) => {
    setShowSubNav((prevStates) => {
      // console.log("prev state", prevStates);
      const updatedStates = {};

      // Toggle the value for the specified navItem
      Object.keys(prevStates).forEach((key) => {
        updatedStates[key] = key === navItem && !prevStates[key];
      });

      return updatedStates;
    });
  };

  //set media as default active menu for other roles
  useEffect(() => {
    if (!isAdmin) {
      const updateActiveMenu = {
        users: false,
        media: true,
        subScription: false,
      };
      setShowSubNav(updateActiveMenu); //redux state update
    }
  }, [isAdmin]);

  // Persist the updated `showSubNav` after the state change
  useEffect(() => {
    persistMenuBar(showSubNav); //redux state update
  }, [showSubNav, activeMenuBar]);

  //tabs which don't have sub-navigation's use this function
  const deActiveNavBar = () => {
    setShowSubNav(() => {
      const updatedStates = {};

      Object.keys(showSubNav).forEach((key) => (updatedStates[key] = false));

      return updatedStates;
    });
  };

  const userSubNavigation = [
    permission?.includes("admin_panel_user_management") && {
      navTitle: "Admin Panel User",
      path: ADMIN_PANEL_USER_MANAGEMENT,
    },
    permission?.includes("mobile_app_user_management") && {
      navTitle: "Mobile App User",
      path: MOBILE_APP_USER_MANAGEMENT,
    },
  ].filter(Boolean);

  const mediaSubNavigation = [
    permission?.includes("youtube_content") && {
      navTitle: "YouTube",
      path: YOUTUBE_MANAGEMENT,
    },
    ENABLE_BANNER_SCREEN &&
      permission?.includes("banner-content") && {
        // permission?.includes("banner-content") && {
        navTitle: "Banners",
        path: BANNER_MANAGEMENT,
      },
    permission?.includes("notification_content") && {
      // permission?.includes("banner-content") && {
      navTitle: "Notifications",
      path: NOTIFICATION_MANAGEMENT,
    },
  ].filter(Boolean);

  const subscriptionSubNavigation = [
    permission?.includes("user_management") && {
      navTitle: "Transaction History",
      path: TRANSACTION_HISTORY,
    },
  ].filter(Boolean);

  // //check if window path is not subnav of content management
  // const windowPath = window.location?.pathname;
  // const isOutsideContentManagement =
  //   windowPath !== YOUTUBE_MANAGEMENT && windowPath !== BANNER_MANAGEMENT;

  // if (isOutsideContentManagement) {
  //   deActiveNavBar();
  // }

  // useEffect(() => {
  //   // Check if the current path is outside content management
  //   const windowPath = window.location?.pathname;
  //   const isOutsideContentManagement =
  //     windowPath !== YOUTUBE_MANAGEMENT && windowPath !== BANNER_MANAGEMENT;

  //   if (isOutsideContentManagement) {
  //     // deActiveNavBar();
  //     showChildNav("subscription");
  //   }
  // }, [window.location?.pathname]); // Dependency on pathname, so it runs when the path changes

  return (
    <>
      <div
        className={`sidenav_wrapper_box  ${
          isOpen ? "sidenav_wrapper_box_open" : "sidenav_wrapper_box_close"
        }`}
      >
        <Container bsPrefix="custom" className="container">
          <div className="header-section">
            {/* <span className="me-1"></span> */}
            <span className="content-wrapper">
              <span className="title-content-Wrapper">
                <span className="main-title">
                  <img className="logo" src={logo} alt="Logo" />
                </span>
              </span>
            </span>
          </div>

          <Navbar className="sidenav_wrapper_box_navbar">
            <Nav className="flex-column">
              <div className="main-nav-section p-1">
                {/* {permission?.includes("user_management") && (
                  <NavLink
                    className="nav-link mt-1"
                    exact
                    // to={rowReordered ? "#" : USER_MANAGEMENT}
                    to={USER_MANAGEMENT}
                    onClick={(e) => {
                      if (showSelection && isRowsSelected) {
                        //this is called during navigation to other pages where selection of row is active in youtube management
                        e.preventDefault();
                        setNavigatingToOtherPageWarningModal(
                          true,
                          USER_MANAGEMENT
                        );
                      }
                      if (rowReordered) {
                        e.preventDefault();
                        setRowReorderWarningModal(true, USER_MANAGEMENT);
                      } else {
                        deActiveNavBar();
                      }
                      if (!rowReordered) {
                        resetBannerScreenFilter();
                      }
                    }}
                  >
                    <span className="nav-list-icon side_nav_content">
                      User Management
                    </span>
                  </NavLink>
                )} */}

                {permission?.includes("user_management") && (
                  <>
                    <div
                      className={`nav-link mt-1 ${
                        showSubNav["users"] && "active"
                      }`}
                      onClick={() => {
                        showChildNav("users");
                      }}
                    >
                      {" "}
                      <span className="side_nav_content">
                        <span className="nav-title-wrapper">
                          <div className="nav-list-icon">User Management</div>
                          <span>
                            {showSubNav.users ? (
                              <FaAngleDown color="#6D2926" />
                            ) : (
                              <FaAngleRight color="#eca55a" />
                            )}
                          </span>
                        </span>
                      </span>
                    </div>
                    <div className="nav-dropdown-container">
                      {showSubNav.users &&
                        userSubNavigation?.map((navItem) => {
                          return (
                            <ul key={navItem?.navTitle}>
                              <li className="list">
                                <NavLink
                                  className="nav-link sub-nav mt-1"
                                  exact
                                  to={navItem?.path}
                                  // to={rowReordered ? "#" : navItem?.path}
                                  onClick={(e) => {
                                    // if (
                                    //   navItem?.navTitle !== "Banners" &&
                                    //   !rowReordered
                                    // ) {
                                    //   resetBannerScreenFilter();
                                    // }
                                  }}
                                >
                                  <span className="side_nav_content">
                                    {navItem?.navTitle}
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          );
                        })}
                    </div>
                  </>
                )}

                {permission?.includes("content_management") && (
                  <>
                    <div
                      className={`nav-link mt-1 ${
                        (showSubNav["media"] ||
                          !permission?.includes(
                            "admin_panel_user_management"
                          )) &&
                        "active"
                      }`}
                      onClick={() => {
                        showChildNav("media");
                      }}
                    >
                      {" "}
                      <span className="side_nav_content">
                        <span className="nav-title-wrapper">
                          <div className="nav-list-icon">
                            Content Management
                          </div>
                          <span>
                            {showSubNav.media ? (
                              <FaAngleDown color="#6D2926" />
                            ) : (
                              <FaAngleRight color="#eca55a" />
                            )}
                          </span>
                        </span>
                      </span>
                    </div>
                    <div className="nav-dropdown-container">
                      {showSubNav.media &&
                        mediaSubNavigation?.map((navItem) => {
                          return (
                            <ul key={navItem?.navTitle}>
                              <li className="list">
                                <NavLink
                                  className="nav-link sub-nav mt-1"
                                  exact
                                  to={navItem?.path}
                                  // to={rowReordered ? "#" : navItem?.path}
                                  onClick={(e) => {
                                    // if (
                                    //   navItem?.navTitle !== "Banners" &&
                                    //   !rowReordered
                                    // ) {
                                    //   resetBannerScreenFilter();
                                    // }
                                  }}
                                >
                                  <span className="side_nav_content">
                                    {navItem?.navTitle}
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          );
                        })}
                    </div>
                  </>
                )}

                {/* {permission?.includes("user_management") && (
                  <>
                    <div
                      className={`nav-link mt-1 ${
                        showSubNav["subScription"] && "active"
                      }`}
                      onClick={() => {
                        showChildNav("subScription");
                      }}
                    >
                      {" "}
                      <span className="side_nav_content">
                        <span className="nav-title-wrapper">
                          <div className="nav-list-icon">Subscription</div>
                          <span>
                            {showSubNav.subScription ? (
                              <FaAngleDown color="#6D2926" />
                            ) : (
                              <FaAngleRight color="#eca55a" />
                            )}
                          </span>
                        </span>
                      </span>
                    </div>
                    <div className="nav-dropdown-container">
                      {showSubNav.subScription &&
                        subscriptionSubNavigation?.map((navItem) => {
                          return (
                            <ul key={navItem?.navTitle}>
                              <li className="list">
                                <NavLink
                                  className="nav-link sub-nav mt-1"
                                  exact
                                  to={navItem?.path}
                                  // to={rowReordered ? "#" : navItem?.path}
                                  onClick={(e) => {
                                    // if (
                                    //   navItem?.navTitle !== "Banners" &&
                                    //   !rowReordered
                                    // ) {
                                    //   resetBannerScreenFilter();
                                    // }
                                  }}
                                >
                                  <span className="side_nav_content">
                                    {navItem?.navTitle}
                                  </span>
                                </NavLink>
                              </li>
                            </ul>
                          );
                        })}
                    </div>
                  </>
                )} */}

                {/* {permission?.includes("contributor") && (
                  <NavLink
                    className="nav-link mt-1"
                    exact
                    to={TEST_SCREEN}
                    onClick={() => deActiveNavBar()}
                  >
                    <span className="nav-list-icon side_nav_content">
                      Contributor
                    </span>
                  </NavLink>
                )} */}
              </div>
            </Nav>
          </Navbar>
        </Container>
      </div>
    </>
  );
};

const Sidebar = ({
  logout,
  isOpen,
  hideSidebar,
  state,
  userPermissions,
  rowReordered,
  setRowReorderWarningModal,
  setNavigatingToOtherPageWarningModal,
  resetBannerScreenFilter,
  showSelection,
  persistMenuBar,
}) => {
  return RenderSidebar(
    logout,
    isOpen,
    hideSidebar,
    state,
    userPermissions,
    rowReordered,
    setRowReorderWarningModal,
    setNavigatingToOtherPageWarningModal,
    resetBannerScreenFilter,
    showSelection,
    persistMenuBar
  );
};

Sidebar.propTypes = {
  //logout: PropTypes.func.isRequired,
};

export default Sidebar;
